var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.144043,
    width: 40,
    height: 40,
    rx: 5,
    fill: "#5DA196"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2913_66658)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(30.146 30) rotate(-180)",
    fill: "#5DA196"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.271 28.75L27.021 28.75C27.3525 28.75 27.6705 28.6183 27.9049 28.3839C28.1393 28.1495 28.271 27.8315 28.271 27.5L28.271 12.5C28.271 12.1685 28.1393 11.8505 27.9049 11.6161C27.6705 11.3817 27.3525 11.25 27.021 11.25L13.271 11.25C12.9395 11.25 12.6215 11.3817 12.3871 11.6161C12.1527 11.8505 12.021 12.1685 12.021 12.5L12.021 27.5C12.021 27.8315 12.1527 28.1495 12.3871 28.3839C12.6215 28.6183 12.9395 28.75 13.271 28.75ZM27.021 30C27.684 30 28.3199 29.7366 28.7888 29.2678C29.2576 28.7989 29.521 28.163 29.521 27.5L29.521 12.5C29.521 11.837 29.2576 11.2011 28.7888 10.7322C28.3199 10.2634 27.684 10 27.021 10L13.271 10C12.608 10 11.9721 10.2634 11.5032 10.7322C11.0344 11.2011 10.771 11.837 10.771 12.5L10.771 27.5C10.771 28.163 11.0344 28.7989 11.5032 29.2678C11.9721 29.7366 12.608 30 13.271 30L27.021 30Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.521 27.5L20.771 27.5C21.4614 27.5 22.021 26.9404 22.021 26.25L22.021 22.5C22.021 21.8096 21.4614 21.25 20.771 21.25L19.521 21.25C18.8306 21.25 18.271 21.8096 18.271 22.5L18.271 26.25C18.271 26.9404 18.8306 27.5 19.521 27.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.521 27.5L25.771 27.5C26.4614 27.5 27.021 26.9404 27.021 26.25L27.021 17.5C27.021 16.8096 26.4614 16.25 25.771 16.25L24.521 16.25C23.8306 16.25 23.271 16.8096 23.271 17.5L23.271 26.25C23.271 26.9404 23.8306 27.5 24.521 27.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.521 27.5L15.771 27.5C16.4614 27.5 17.021 26.9404 17.021 26.25L17.021 13.75C17.021 13.0596 16.4614 12.5 15.771 12.5L14.521 12.5C13.8306 12.5 13.271 13.0596 13.271 13.75L13.271 26.25C13.271 26.9404 13.8306 27.5 14.521 27.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2913_66658"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(30.146 30) rotate(-180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartGreen);
export default __webpack_public_path__ + "static/media/chart-green.143028ce2c6973c2f3b58f8121f9120b.svg";
export { ForwardRef as ReactComponent };